import React, { Component } from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';
import './Welcome.scss';
import store from '@/store';
import { getQueryVariable } from '@/utils/utils';
import { isMobile } from '@/utils/device';

export default class Welcome extends Component {
  constructor(props) {
    super(props);

    this.Welcome;
    this.Content;
    this.SignIn;
    this.from = getQueryVariable('source');
    this.state = {};
  }
  componentDidMount() {}
  componentWillUnmount() {}
  initIntlLang = () => {
    this.Welcome = intl.formatMessage({ id: 'Welcome.title' });
    this.SignIn = intl.formatMessage({ id: 'Welcome.SignIn' });

    if (this.from === 'online') {
      this.Content = intl.formatMessage({ id: 'Welcome.OnlineContent' });
    }
    if (this.from === 'phantompdf') {
      this.Content = intl.formatMessage({ id: 'Welcome.PhantomPdfContent' });
    }
  };
  onSignIn() {
    store.userStore.loginIn(null, { isFromUserHandleLogin: true });
  }
  onCloseWelcome() {
    store.userStore.doHideWelcomeDlg();
  }
  render() {
    if (isMobile) return null;
    const { hasOpenFile } = store.viewer;
    if (hasOpenFile) return null;
    const { hasSignIn, isShowWelcomeDlg, popupSignUpOrSignIn } = store.userStore;
    if (hasSignIn) return null;
    if (!isShowWelcomeDlg) return null;
    if (popupSignUpOrSignIn) return null;
    this.initIntlLang();

    return (
      <React.Fragment>
        <div className="online-modal-mask">
          <div className="welcome-wrapper online-modal rem absolute-center">
            <div className="header">
              <div className="title">{this.Welcome}</div>
              <i className="close-btn fv__icon-layer-close" onClick={this.onCloseWelcome}></i>
            </div>
            <div className="body">
              <div className="welcome-img" />
              <div className="content">{this.Content}</div>
            </div>
            <div className="footer">
              <Button type="primary" onClick={this.onSignIn}>
                {this.SignIn}
              </Button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
